import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import * as actions from 'react/api/actions/stopDetailsPopup';
import ButtonWithIcon from 'react/components/ButtonWithIcon';
import { 
  arrivalLocationIcon,
  arrivalLocationIconActive
} from 'react/utils/stopDetailsPopupBase64Icons.js';

class ArrivalLocationButton extends Component {
  
  toggleArrivalLocation = (e) => {
    const {
      routeId, stopId, enableArrivalLocationAction, 
      disableArrivalLocationAction, arrivalLocationIsEnabled,
      addArrivalLocationToMapAction, removeArrivalLocationFromMapAction
    } = this.props;
    e.stopPropagation();
    removeArrivalLocationFromMapAction(routeId, stopId);
    if (arrivalLocationIsEnabled) {
      disableArrivalLocationAction(routeId, stopId);
    } else {
      enableArrivalLocationAction(routeId, stopId);
      addArrivalLocationToMapAction(routeId, stopId);
    }
  }

  componentDidMount = () => {
    const {
      routeId, stopId, arrivalLocationIsEnabled,
      addArrivalLocationToMapAction
    } = this.props;
    if (arrivalLocationIsEnabled) {
      addArrivalLocationToMapAction(routeId, stopId);
    }
  }

  render() {
    const { arrivalLocationIsEnabled, ...others } = this.props;
    return (
      <ButtonWithIcon
      label={Monet.I18n.getResourcesByKey('routeDetails.stopDetailsPopup.zones.arrivalLocation')}
      isActive={arrivalLocationIsEnabled} 
      iconUrl={arrivalLocationIcon}
      activeIconUrl={arrivalLocationIconActive}
      onClick={this.toggleArrivalLocation}
      {...others}/>
    );
  }
}

ArrivalLocationButton.propTypes = {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  arrivalLocationIsEnabled: PropTypes.bool.isRequired,
  enableArrivalLocationAction: PropTypes.func.isRequired,
  disableArrivalLocationAction: PropTypes.func.isRequired,
  addArrivalLocationToMapAction: PropTypes.func.isRequired,
  removeArrivalLocationFromMapAction: PropTypes.func.isRequired
}

const mapStateToProps = ({ stopDetailsPopup }, { routeId, stopId }) => ({ 
  arrivalLocationIsEnabled: stopDetailsPopup.getIn(['actionButtons', String(routeId), String(stopId), 'arrivalLocationIsEnabled'], false)
});

const mapDispatchToProps = (dispatch) => ({
  enableArrivalLocationAction: bindActionCreators(actions.enableArrivalLocation, dispatch),
  disableArrivalLocationAction: bindActionCreators(actions.disableArrivalLocation, dispatch),
  addArrivalLocationToMapAction: bindActionCreators(actions.addArrivalLocationToMap, dispatch),
  removeArrivalLocationFromMapAction: bindActionCreators(actions.removeArrivalLocationFromMap, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ArrivalLocationButton);

